/**
 * Model responsible for shepherding a Foundation.Member object through the
 * third party authentication and login process. Fires events on itself that
 * Foundation.Login.Dialog observes. Is also used by the CreateAccountExtras
 * and LinkAccount subview controllers.
 * @constructor
 * @extends {Foundation.Observable}
 * @param {Foundation.Member} member
 * @param {!Foundation.Login.ThirdPartyAuthenticator} authenticator
 */
Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd = function (member, authenticator) {
    Foundation.Observable.call(this)

    /**
     * @private
     * @type {!Foundation.Login.ThirdPartyAuthenticator}
     */
    this._authenticator = authenticator

    /**
     * @private
     * @type {Foundation.Member}
     */
    this._member = member
}
Foundation.inherit(Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd, Foundation.Observable)

/**
 * Kicks off the whole process. Tells our third party authenticator to
 * attempt to authenticate the user.
 */
Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd.prototype.authenticate = function () {
    this.fire("auth-start")

    // Authenticate with FB, Google, Twitter, etc. first
    this._authenticator.authenticateWithThirdPartyService().then(function () {
        // FB, Google, Twitter, etc. Auth failed
        // Authenticate with Foundation
        this._authenticator.authenticateWithFoundation().then(function () {
            // Foundation Auth Success
            this.fire("auth-complete")
            this._performLogIn()
        }.bind(this), function () {
            // Foundation Auth Fail - FB, Google, Twitter, etc. Member not in Foundation
            // Setup new Member info
            this._member.extend({
                "email": this._authenticator.suggestedUserEmailAddress() || "",
                "userName": this._authenticator.suggestedUserName() || "",
                "fullName": this._authenticator.suggestedUserFullName() || ""
            })
            this.fire("auth-complete")

            // Potential member merge scenario
            if (this._authenticator.accountIsLikelyToCollide()) {
                this.fire("need-login-to-link-account")
            }
            // New member
            else {
                this.fire("need-new-account")
            }
        }.bind(this))
    }.bind(this), function () {
        // FB, Google, Twitter, etc. Auth failed
        this.fire("auth-complete")
    }.bind(this))
}

/**
 * @return {!Foundation.Login.ThirdPartyAuthenticator}
 */
Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd.prototype.authenticator = function () {
    return this._authenticator
}

/**
 * Log the user in.
 * @private
 */
Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd.prototype._performLogIn = function () {
    var sessionManager = Foundation.Session.Manager.sharedInstance()
    var delegateID = this._authenticator.sessionManagerDelegateID()
    var ttl = this._authenticator.sessionTTL()
    this._member.extend({
        "oid": this._authenticator.memberOid(),
        "userName": this._authenticator.memberUserName(),
        "avatarUrl": this._authenticator.memberAvatarUrl()
    })
    sessionManager.logIn(delegateID, this._member, ttl)
}
